export default function addPolyfills() {
    // forEach method on NodeList Object
    if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = Array.prototype.forEach;
    }

    // isNaN method on Window and Number Object
    window.isNaN = function(n){
        return Number(n) !== Number(n);
    }
    
    window.Number.isNaN = function(n){
        return n !== n;
    }
    
    // repeat method on String Object
    if (!String.prototype.repeat) {
        String.prototype.repeat = function(count) {
            'use strict';

            if (this == null) {
                throw new TypeError('can\'t convert ' + this + ' to object');
            }
        
            var str = '' + this;

            // To convert string to integer.
            count = +count;

            // Check NaN
            if (count != count) {
                count = 0;
            }
        
            if (count < 0) {
                throw new RangeError('repeat count must be non-negative');
            }
        
            if (count == Infinity) {
                throw new RangeError('repeat count must be less than infinity');
            }
        
            count = Math.floor(count);
            if (str.length == 0 || count == 0) {
                return '';
            }
        
            // Ensuring count is a 31-bit integer allows us to heavily optimize the
            // main part. But anyway, most current (August 2014) browsers can't handle
            // strings 1 << 28 chars or longer, so:
            if (str.length * count >= 1 << 28) {
                throw new RangeError('repeat count must not overflow maximum string size');
            }
        
            var maxCount = str.length * count;
            count = Math.floor(Math.log(count) / Math.log(2));
            while (count) {
                str += str;
                count--;
            }
            str += str.substring(0, maxCount - str.length);

            return str;
        }
    }
    
    // CustomEvent on Window Object
    if (typeof window.CustomEvent !== 'function') {
        function CustomEvent(event, params) {
            params = params || { bubbles: false, cancelable: false, detail: undefined };
            var evt = document.createEvent('CustomEvent');
            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);

            return evt;
        }

        CustomEvent.prototype = window.Event.prototype;
        window.CustomEvent = CustomEvent;
    }
    // A desactiver pour voir si le bug des images étirées apparait aussi sur IE11...
    function objectFit(image) {
        if ('objectFit' in document.documentElement.style === false /*&& image.currentStyle['object-fit']*/) {
            image.style.background = 'url("' + image.src + '") no-repeat 50%/cover';
            image.src = '';
        }
    }
    document.querySelectorAll('img').forEach($img => {
        // objectFit($img);
    });

};
